/* Copyright(c) 2019 APSS Media Pvt. Ltd.
*  All Rights Reserved
*/
/**
* @file addApiPortal.js
* @description Task-5934  This component is used to add new API integration portal or edit existing portal details like portal name, portal url, lead delivery urls and other parameters if any. It has form validation for all the fields and shows error message if validation fails. It also shows success message if portal is added/updated successfully.
* @author  Anshul Sarade
* @section use for admin 
*/

import React, { Component } from 'react';
import AdminNavpage from './adminNavpage';
import Footer from './footer';
import './addApiPortal.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logoutUser } from '../login/authentication';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import { FaArrowAltCircleLeft, FaExclamationCircle } from "react-icons/fa";
import "../campaign/loader.css"

const customStyles = {
    control: (provided) => ({
        ...provided,
        width: "300px",
        minHeight: "38px",
        borderRadius: "10px",
        boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
        cursor: 'pointer'
    }),

    menuList: (provided) => ({
        ...provided,
        maxHeight: 300,
    }),
    option: (provided, state) => ({
        ...provided,
        color: 'black',
        backgroundColor: state.isFocused ? provided.backgroundColor : provided.backgroundColor,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: 'black'
    }),

};
const Swal = require('sweetalert2');

class addApiPortal extends Component {

    state = {
        integrationPortalOptions: [],
        selectedIntegration: null,
        isAddingNew: false,
        isTopPlusDisabled: false,
        searchTerm: "",
        integrationPortalName: "",
        fileType: "",
        fileTypeError: "",
        url: "",
        leadUrls: [],
        leadUrlKeys: [],
        parameters: [],
        parameterKeys: [],
        portalNameInputError: false,
        loader_progress: "loader_campaign_list",
        showMainUrlError: false, //Anshul-6008: added to show error message for main url field
        showLeadDelUrlErrors: [], // Anshul-6008: added to show error messages for lead delivery url fields individually
    };

    componentDidMount() {
        this.fetchintegrationPortalList();
    }

    
    normalizePortalName = (name) => (name || '').toLowerCase(); // Anshul-6009: removed .trim() 
    normalizeFieldValue = (value) => String(value || '').toLowerCase();
    isAlphanumeric = (value) => {
        const trimmed = String(value || '');//Anshul-6017: removed .trim() to restrict space
        return /^[a-z0-9]{2,}$/i.test(trimmed) && /[a-z]/i.test(trimmed);// Anshul-6009: restricted to minimum 2 characters allow
    };

    // Anshul-6008: updated url validation
    // isInvalidUrlValue = (value) => {
    //     const trimmed = String(value || '').trim();
    //     if (!trimmed) return false;
    //     const onlyNumbers = /^\d+$/.test(trimmed);
    //     const onlySymbols = /^[^a-zA-Z0-9]+$/.test(trimmed);
    //     const onlySlashes = /^\/+$/.test(trimmed);
    //     return onlyNumbers || onlySymbols || onlySlashes;
    // };

    // isInvalidUrlValue = (value) => {
    //     const str = String(value || '');

        
    //     if (/\s/.test(str)) return true;
    //     const trimmed = str.trim();
    //     const onlyNumbers = /^\d+$/.test(trimmed);
    //     const onlySymbols = /^[^a-zA-Z0-9]+$/.test(trimmed);
    //     const onlySlashes = /^\/+$/.test(trimmed);

    //     return onlyNumbers || onlySymbols || onlySlashes;
    // };


    // isInvalidUrlValue = (value) => {
    //     const trimmed = String(value || '').trim();
    //     if (!trimmed) return false;

    //     let pattern1 = new RegExp(
    //         /(http(s)?:)?([\w-]+\.)+[\w-]+([\w- ;,.?%&=]*)?/
    //     );

    //     return !pattern1.test(trimmed);
    // };
    

    isInvalidUrlValue = (value) => {
        if (!value) return false; // Anshul-6009: removed .trim()
        const strictUrlPattern = /^https?:\/\/[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+(:\d+)?(\/[^\s]*)?$/;
        return !strictUrlPattern.test(value); // Anshul-6009: removed .trim()
    };



    getInvalidUrlIndexSet = (values = []) => {
        const invalidIndexes = new Set();
        values.forEach((value, index) => {
            if (this.isInvalidUrlValue(value)) {
                invalidIndexes.add(index);
            }
        });
        return invalidIndexes;
    };

    hasDuplicateValues = (values = []) => {
        const normalized = values
            .map(this.normalizeFieldValue)
            .filter(Boolean);
        return new Set(normalized).size !== normalized.length;
    };

    getDuplicateIndexSet = (values = []) => {
        const seen = new Set();
        const duplicateIndexes = new Set();
        values.forEach((value, index) => {
            const normalized = this.normalizeFieldValue(value);
            if (!normalized) return;
            if (seen.has(normalized)) {
                duplicateIndexes.add(index);
            } else {
                seen.add(normalized);
            }
        });
        return duplicateIndexes;
    };

    getInvalidParameterIndexSet = (values = []) => {
        const invalidParameterIndexes = new Set();
        // Anshul-6013: updated validations for parameters
        values.forEach((value, index) => {
            const trimmed = String(value || '');//Anshul-6017: removed .trim() to restrict space

            if (!trimmed) return;

            const isValidParameter =
                /^[a-zA-Z0-9_-]{2,}$/.test(trimmed) &&
                /[a-zA-Z]/.test(trimmed);

            if (!isValidParameter) {
                invalidParameterIndexes.add(index);
            }
        });
        return invalidParameterIndexes;
    };

    isDuplicatePortalName = (name) => {
        const normalizedName = this.normalizePortalName(name);
        if (!normalizedName) return false;

        const currentPortalId =
            (this.state.selectedIntegration &&
                this.state.selectedIntegration.raw &&
                this.state.selectedIntegration.raw.clientPortalID) ||
            (this.state.selectedIntegration && this.state.selectedIntegration.value);

        return this.state.integrationPortalOptions.some((option) => {
            const optionName = this.normalizePortalName(option.label);
            const optionPortalId =
                (option.raw && option.raw.clientPortalID) || option.value;

            if (
                currentPortalId !== undefined &&
                currentPortalId !== null &&
                String(optionPortalId) === String(currentPortalId)
            ) {
                return false;
            }

            return optionName === normalizedName;
        });
    };

    fetchintegrationPortalList = () => {
        fetch('/admin/integrationPortalList')
            .then((res) => res.json())
            .then((data) => {
                const options = Array.isArray(data)
                    ? data.map((p) => ({
                        value: p.clientPortalID,
                        label: p.clientPortalName,
                        raw: p
                    }))
                    : [];
                this.setState({ integrationPortalOptions: options, loader_progress: "", });
            })
            .catch((err) => {
                console.error('Failed to fetch portals:', err);
                this.setState({ integrationPortalOptions: [] });
            });
    };

    handleEditFromDropdown = (integrationPortalData) => {
        // for updating existing Integration Portal  pre-fill the input fields with existing data
        const raw = integrationPortalData.raw || {};
        const url = raw.clientLoginURL || raw.loginUrl || raw.url || '';
        const fileType = (raw.deliveryFileType || raw.fileType || "").toString().toLowerCase();
        // extracting lead urls
        let leadUrls = [];
        const urlProps = Object.keys(raw).filter(k => k.startsWith('leadDeliveryUrl'));
        if (urlProps.length > 0) {
            leadUrls = urlProps
                .sort()
                .map(k => raw[k])
                .filter(v => typeof v === 'string' ? v !== '' : Boolean(v)); // Anshul-6009: removed .trim()
        }

        // extracting the parameters from fieldKey* 
        let parameters = [];
        let parameterKeys = [];
        const paramProps = Object.keys(raw).filter(k =>
            /\d+$/.test(k) &&
            !k.startsWith('leadDeliveryUrl') &&
            !k.startsWith('portal_') &&
            k !== 'clientPortalID' && k !== 'clientPortalName'
        );
        if (paramProps.length > 0) {
            const filteredPairs = paramProps
                .sort()
                .map(k => ({ key: k, value: raw[k] }))
                .filter(item =>
                    typeof item.value === 'string'
                        ? item.value !== '' // Anshul-6009: removed .trim()
                        : Boolean(item.value)
                );
            parameterKeys = filteredPairs.map(item => item.key);
            parameters = filteredPairs.map(item => item.value);
        }

        this.setState({
            isAddingNew: true,
            selectedIntegration: integrationPortalData,
            integrationPortalName: integrationPortalData.label || '',
            url,
            leadUrls,
            parameters,
            parameterKeys,
            fileType,
            portalNameInputError: false,
            showMainUrlError: false, //Anshul-6008: reset main url error when selecting from dropdown
            showLeadDelUrlErrors: [], // Anshul-6008: reset lead delivery url errors when selecting from dropdown
            
        });
    };

    handlePlusClick = () => {
        // Creating new Integration Portal
        this.setState({
            isAddingNew: true,
            selectedIntegration: null,
            integrationPortalName: '',
            url: '',
            leadUrls: [],
            parameters: [],
            parameterKeys: [],
            fileType: "",
            portalNameInputError: false,
            showLeadDelUrlErrors: [],
            showMainUrlError: false
        });
    };

    handleTopPlusIconClick = () => {
        if (this.state.isTopPlusDisabled) return;
        this.setState({ isTopPlusDisabled: true }, this.handlePlusClick);
    };

    CustomOption = (props) => {
        const { data, innerProps } = props;

        return (
            <div
                {...innerProps}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "8px 12px",
                    cursor: "pointer",
                    whiteSpace: "nowrap"
                }}
            >
                {/* Portal Name */}
                <div
                    style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        flex: 1
                    }}
                >
                    {data.label}
                </div>

            </div>
        );
    };


    handleLeadUrlChange = (i, val) => {
        const arr = [...this.state.leadUrls];
        arr[i] = val;
        const updatedLeadUrlErrors = [...this.state.showLeadDelUrlErrors];
        updatedLeadUrlErrors[i] = false;
        this.setState({
            leadUrls: arr,
            showLeadDelUrlErrors: updatedLeadUrlErrors
        });
    };

    addLeadUrl = () => {
        if (this.state.leadUrls.length >= 4) return;

        this.setState(prev => ({
            leadUrls: [...prev.leadUrls, ""],
            showLeadDelUrlErrors: [...prev.showLeadDelUrlErrors, false]
        }));
    };

    removeLeadUrl = (index) => {
        this.setState(prev => {
            const updated = [...prev.leadUrls];
            const updatedLeadUrlErrors = [...prev.showLeadDelUrlErrors];
            updated.splice(index, 1);
            updatedLeadUrlErrors.splice(index, 1);
            return {
                leadUrls: updated,
                showLeadDelUrlErrors: updatedLeadUrlErrors
            };
        });
    };


    addParameter = () => {
        if (this.state.parameters.length >= 5) return;

        this.setState(prev => ({
            parameters: [...prev.parameters, ""]
        }));
    };

    handleParamChange = (i, val) => {
        const arr = [...this.state.parameters];
        arr[i] = val;
        this.setState({ parameters: arr });
    };

    removeParam = (i) => {
        this.setState({
            parameters: this.state.parameters.filter((_, x) => x !== i)
        });
    };

    submitForm = () => {
       
        Swal.fire({
            onOpen: () => {
                Swal.showLoading();

                const { integrationPortalName, url, selectedIntegration } = this.state;
                const isDuplicateName = this.isDuplicatePortalName(integrationPortalName);
                const hasInvalidPlatformName = !this.isAlphanumeric(integrationPortalName);
                const hasInvalidMainUrl = this.isInvalidUrlValue(url);
                const hasDuplicateLeadUrls = this.hasDuplicateValues(this.state.leadUrls);
                const hasInvalidLeadUrls = this.state.leadUrls.some((leadUrl) => this.isInvalidUrlValue(leadUrl));
                const hasDuplicateParameters = this.hasDuplicateValues(this.state.parameters);
                // Anshul-6013: updated validations for parameters
                const hasInvalidParameters = this.state.parameters.some((param) => {
                    const trimmed = String(param || '');//Anshul-6017: removed .trim() to restrict space
                    if (!trimmed) return false;
                    return !(
                        /^[a-zA-Z0-9_-]{2,}$/.test(trimmed) &&
                        /[a-zA-Z]/.test(trimmed)
                    );
                });
                const hasEmptyLeadUrls = this.state.leadUrls.some((leadUrl) => !String(leadUrl || ''));// Anshul-6009: removed .trim()
                const hasEmptyParameters = this.state.parameters.some((param) => !String(param || ''));

                if (!integrationPortalName) {
                    return;
                }

                if (!url) { // Anshul-6009: removed .trim()
                    Swal.close();
                    return;
                }
                /*
                if (hasInvalidMainUrl) {
                    this.setState({ showMainUrlError: true });
                    Swal.close();
                    return;
                }
                */

                /*
                if (hasInvalidLeadUrls) {
                    this.setState({
                        showLeadDelUrlErrors: this.state.leadUrls.map((leadUrl) => this.isInvalidUrlValue(leadUrl))
                    });
                    Swal.close();
                    return;
                }
                */

                if (hasInvalidMainUrl || hasInvalidLeadUrls) {
                    this.setState({
                        showMainUrlError: hasInvalidMainUrl,
                        showLeadDelUrlErrors: this.state.leadUrls.map((leadUrl) => this.isInvalidUrlValue(leadUrl))
                    });
                    Swal.close();
                    return;
                }

                if (isDuplicateName) {
                    return;
                }
                if (hasInvalidPlatformName) {
                    console.log('true');
                    return;
                }

                if (hasDuplicateLeadUrls) {
                    return;
                }

                if (hasDuplicateParameters) {
                    return;
                }
                if (hasInvalidParameters) {
                    return;
                }
                if (hasEmptyLeadUrls) {
                    return;
                }
                if (hasEmptyParameters) {
                    return;
                }

                if (!this.state.fileType) {
                    this.setState({ fileTypeError: "Please select delivery file type" });
                    return;
                }


                const payload = {
                    name: integrationPortalName,
                    clientLoginURL: this.state.url || '',
                    deliveryFileType: this.state.fileType
                };

                // adding numbers with lead delivery urls
                this.state.leadUrls.forEach((url, i) => {
                    if (url) {
                        payload[`leadDeliveryUrl${i + 1}`] = url;
                    }
                });


                if (this.state.parameterKeys && this.state.parameterKeys.length > 0) {
                    this.state.parameters.forEach((param, i) => {
                        if (param && this.state.parameterKeys[i]) {
                            payload[this.state.parameterKeys[i]] = param;
                        }
                    });
                } else {
                    this.state.parameters.forEach((param, i) => {
                        if (param) {
                            payload[`fieldKey${i + 1}`] = param;
                        }
                    });
                }

                // If editing, include clientPortalID
                if (selectedIntegration && selectedIntegration.raw && selectedIntegration.raw.clientPortalID) {
                    payload.clientPortalID = selectedIntegration.raw.clientPortalID;
                }

                fetch('/admin/addintegrationPortal', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                })
                    .then(async (res) => {
                        const body = await res.json().catch(() => ({}));
                        if (res.ok) {

                            Swal.fire({
                                text: "API Integration configured successfully",
                                type: "success",
                                confirmButtonText: "Ok",
                                allowOutsideClick: false,
                                preConfirm: () => {
                                    window.location.reload(); 
                                },
                            });


                        } else {
                            Swal.fire({
                                type: "error",
                                text: body.message || 'Failed to save portal',
                                icon: "error",
                                preConfirm: () => {
                                    window.location.reload();
                                },
                            });
                        }
                    })
                    .catch((err) => {
                        console.error('Submit error:', err);
                        Swal.fire({
                            type: "error",
                            text: err.message || 'Failed to save portal',
                            icon: "error",
                            preConfirm: () => {
                                window.location.reload();
                            },
                        });
                    });
            }
        });

    };

    // handle file type radio button
    handleFileTypeChange = (e) => {
        this.setState({
            fileType: e.target.value,
            fileTypeError: ""
        });
    };

    render() {
        const isEditingExistingPlatform = Boolean(
            this.state.selectedIntegration &&
            this.state.selectedIntegration.raw &&
            this.state.selectedIntegration.raw.clientPortalID
        );

        const duplicateNameError = this.isDuplicatePortalName(this.state.integrationPortalName);
        const invalidNameError =
            this.state.integrationPortalName &&
            !this.isAlphanumeric(this.state.integrationPortalName);
        /*
        const invalidMainUrlError =
            this.state.url.trim() && this.isInvalidUrlValue(this.state.url);
        */
        const invalidMainUrlError = this.state.showMainUrlError && this.isInvalidUrlValue(this.state.url);
        const duplicateLeadUrlIndexes = this.getDuplicateIndexSet(this.state.leadUrls);
        /*
        const invalidLeadUrlIndexes = this.getInvalidUrlIndexSet(this.state.leadUrls);
        */
        const invalidLeadUrlIndexes = new Set(
            this.state.leadUrls.reduce((indexes, leadUrl, index) => {
                if (this.state.showLeadDelUrlErrors[index] && this.isInvalidUrlValue(leadUrl)) {
                    indexes.push(index);
                }
                return indexes;
            }, [])
        );
        const duplicateParameterIndexes = this.getDuplicateIndexSet(this.state.parameters);
        const invalidParameterIndexes = this.getInvalidParameterIndexSet(this.state.parameters);
        const duplicateLeadUrlError = duplicateLeadUrlIndexes.size > 0;
        const invalidLeadUrlError = invalidLeadUrlIndexes.size > 0;
        const duplicateParameterError = duplicateParameterIndexes.size > 0;
        const invalidParameterError = invalidParameterIndexes.size > 0;
        const hasEmptyLeadUrls = this.state.leadUrls.some((leadUrl) => !String(leadUrl || ''));
        const hasEmptyParameters = this.state.parameters.some((param) => !String(param || '')) || !this.state.fileType;
;

        const isSaveDisabled =
            !this.state.integrationPortalName||
            !this.state.url ||
            Boolean(invalidNameError) ||
            // Boolean(invalidMainUrlError) ||
            Boolean(hasEmptyLeadUrls) ||
            Boolean(hasEmptyParameters) ||
            Boolean(duplicateNameError) ||
            Boolean(invalidLeadUrlError) ||
            Boolean(duplicateLeadUrlError) ||
            Boolean(duplicateParameterError) ||
            Boolean(invalidParameterError);

        return (
            <div className="addApiPortalPage">

                <AdminNavpage />

                <div style={{ paddingTop: 100 }}>

                    <div class="row">
                        <div class="col-lg-1 col-md-1 col-sm-1" style={{ float: 'left', marginLeft: '40px' }}>
                            <a
                                class="col"
                                href='adminDashboard'
                                style={{ right: '33%', marginLeft: '80px' }}
                                onClick={() => this.props.history.push("/adminDashboard")}
                            >
                                <FaArrowAltCircleLeft size={32} title="Back to Dashboard" />
                            </a>
                        </div>

                        <div class="col-lg-9 col-md-9 col-sm-9" align="center">
                            <center>
                                <label
                                    id="labelDI"
                                    style={{
                                        fontSize: "28px",
                                        fontStyle: "roboto",
                                        fontWeight: "500",
                                        color: "#193D8F",
                                    }}
                                    align="center"
                                >
                                    Add API Integration Setup
                                </label>
                            </center>
                        </div>
                    </div>

                    {/* first container */}

                    <div className="api-card">

                        <div className="form-row">

                            <label style={{ marginLeft: '50px', marginTop: "8px", }}>API Portal :</label>

                            <Select
                                styles={customStyles}
                                placeholder="Select Integration Portal"
                                value={this.state.selectedIntegration}
                                options={[

                                    ...this.state.integrationPortalOptions,
                                ]}
                                components={{ Option: this.CustomOption }}
                                onChange={(selected) => {
                                    if (!selected) {
                                        this.setState({
                                            selectedIntegration: null,
                                            isTopPlusDisabled: false,
                                            fileType: ""
                                        });
                                        return;
                                    }

                                    if (selected.value === "addNewintegrationPlatform") {
                                        this.handlePlusClick();
                                        return;
                                    }

                                    // When clicking portal name normally → select only
                                    this.setState({ isTopPlusDisabled: false }, () => {
                                        this.handleEditFromDropdown(selected);
                                    });
                                }}
                            />

                            <img
                                src="/add.png"
                                alt="Add"
                                title="Click here to add new Integration Portal"
                                className={`plus-btn ${this.state.isTopPlusDisabled ? "plus-btn-disabled" : ""}`}
                                style={{
                                    width: 24,
                                    height: 24,
                                    cursor: this.state.isTopPlusDisabled ? "not-allowed" : "pointer",
                                    marginLeft: "10px"
                                }}
                                onClick={this.handleTopPlusIconClick}
                            />

                        </div>

                    </div>

                    <div align="center" id={this.state.loader_progress}></div>

                    {/* second container rendering when + icon clicked */}

                    {this.state.isAddingNew && (

                        <div className="api-card">

                            {/* 2 column layout: left (name/url), right (lead delivery urls) */}
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    columnGap: "70px",
                                    rowGap: "25px",
                                    alignItems: "start"
                                }}
                            >
                                <div style={{ display: "grid", rowGap: "25px" }}>
                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                        <label style={{ width: "220px", marginTop: "8px", }}>
                                            API Portal Name<span style={{ color: "red", fontWeight: "bold" }}>*</span> :
                                        </label>
                                        <div
                                            style={{
                                                flex: 1,
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "stretch"
                                            }}
                                        >
                                            <input
                                                placeholder='Enter API Portal Name'
                                                className="form-control"
                                                style={{
                                                    borderRadius: "10px",
                                                    boxShadow: "rgba(71,71,71,0.3) 0px 4px 6px 0px",
                                                    border: duplicateNameError ? "1px solid #d32f2f" : undefined,
                                                    backgroundColor: isEditingExistingPlatform ? "#f2f2f2" : undefined,
                                                    cursor: isEditingExistingPlatform ? "not-allowed" : "text"
                                                }}
                                                disabled={isEditingExistingPlatform}
                                                value={this.state.integrationPortalName}
                                                onChange={(e) => {
                                                    const rawValue = e.target.value;
                                                    this.setState({
                                                        integrationPortalName: rawValue,
                                                        portalNameInputError: /[^a-z0-9]/i.test(rawValue)
                                                    });
                                                }}
                                            />
                                            {(invalidNameError || this.state.portalNameInputError) && (
                                                <div style={{ color: "#e60000", fontSize: "14px", marginTop: "6px" }}>
                                                    <FaExclamationCircle style={{ marginRight: "6px", fontSize: "12px" }} />
                                                    Allowed only alphanumeric values.
                                                </div>
                                            )}
                                            {duplicateNameError && (
                                                <div style={{ color: "#e60000", fontSize: "14px", marginTop: "6px" }}>
                                                    <FaExclamationCircle style={{ marginRight: "6px", fontSize: "12px" }} />
                                                    Portal already exists.
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                        <label style={{ width: "220px", marginTop: "8px" }} >
                                            API Portal URL<span style={{ color: "red", fontWeight: "bold" }}>*</span> :
                                        </label>
                                        <div style={{ flex: 1, display: "flex", flexDirection: "column", }}>
                                            <input
                                                className="form-control"
                                                placeholder="Enter Portal URL"
                                                style={{
                                                    width: "100%",
                                                    borderRadius: "10px",
                                                    boxShadow: "rgba(71,71,71,0.3) 0px 4px 6px 0px",
                                                    border: invalidMainUrlError ? "1px solid #d32f2f" : undefined
                                                }}
                                                value={this.state.url}
                                                /*
                                                onChange={(e) =>
                                                    this.setState({
                                                        url: e.target.value,
                                                        showMainUrlError: true
                                                    })
                                                }
                                                */
                                                onChange={(e) =>
                                                    this.setState({
                                                        url: e.target.value,
                                                        showMainUrlError: false
                                                    })
                                                }
                                            />
                                            {invalidMainUrlError && (
                                                <div style={{ color: "#e60000", fontSize: "14px", marginTop: "6px", display: "block", width: "100%" }}>
                                                    <FaExclamationCircle style={{ marginRight: "6px", fontSize: "12px" }} />
                                                    Please enter valid url.
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", alignItems: "flex-start", marginTop: "10px" }}>
                                        <label style={{ width: "220px", marginTop: "2px" }}>
                                            Delivery File Type <span style={{ color: "red" }}>*</span> :
                                        </label>

                                        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                                                <label style={{ cursor: "pointer", marginBottom: 0 }}>
                                                    <input
                                                        type="radio"
                                                        name="fileType"
                                                        value="excel"
                                                        checked={this.state.fileType === "excel"}
                                                        onChange={this.handleFileTypeChange}
                                                        style={{ marginRight: "6px" }}
                                                    />
                                                    Excel
                                                </label>

                                                <label style={{ cursor: "pointer", marginBottom: 0 }}>
                                                    <input
                                                        type="radio"
                                                        name="fileType"
                                                        value="csv"
                                                        checked={this.state.fileType === "csv"}
                                                        onChange={this.handleFileTypeChange}
                                                        style={{ marginRight: "6px" }}
                                                    />
                                                    CSV
                                                </label>
                                            </div>

                                            {this.state.fileTypeError ? (
                                                <div style={{ color: "red", fontSize: "12px", marginTop: "6px" }}>
                                                    {this.state.fileTypeError}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>



                                </div>

                                <div style={{ display: "grid", rowGap: "25px" }}>
                                    {[0, 1, 2, 3].map((i) => {
                                        if (i >= this.state.leadUrls.length) return null;

                                        return (
                                            <div key={i} style={{ display: "flex", alignItems: "flex-start" }}>
                                                <label style={{ width: "220px", marginTop: "8px" }}>
                                                    Lead Delivery URL {i + 1} :
                                                </label>

                                                <div style={{ flex: 1 }}>
                                                    <input
                                                        className="form-control"
                                                        placeholder={`Enter Lead Delivery URL ${i + 1}`}
                                                        style={{
                                                            borderRadius: "10px",
                                                            boxShadow: "rgba(71,71,71,0.3) 0px 4px 6px 0px",
                                                            border: (duplicateLeadUrlIndexes.has(i) || invalidLeadUrlIndexes.has(i)) ? "1px solid #d32f2f" : undefined
                                                        }}
                                                        value={this.state.leadUrls[i]}
                                                        /*
                                                        onChange={(e) => {
                                                            const arr = [...this.state.leadUrls];
                                                            arr[i] = e.target.value;
                                                            this.setState({ leadUrls: arr });
                                                        }}
                                                        */
                                                        onChange={(e) => this.handleLeadUrlChange(i, e.target.value)}
                                                    />
                                                    {invalidLeadUrlIndexes.has(i) && (
                                                        <div style={{ color: "#e60000", fontSize: "14px", marginTop: "6px" }}>
                                                            <FaExclamationCircle style={{ marginRight: "6px", fontSize: "12px" }} />
                                                            Please enter valid url.
                                                        </div>
                                                    )}
                                                    {duplicateLeadUrlIndexes.has(i) && (
                                                        <div style={{ color: "#e60000", fontSize: "14px", marginTop: "6px" }}>
                                                            <FaExclamationCircle style={{ marginRight: "6px", fontSize: "12px" }} />
                                                            Lead Delivery URL already exists.
                                                        </div>
                                                    )}
                                                </div>

                                                <img
                                                    src="/api-remove-icon.png"
                                                    alt="Remove"
                                                    style={{
                                                        width: 18,
                                                        height: 18,
                                                        cursor: "pointer",
                                                        marginLeft: "8px",
                                                        alignSelf: "flex-start",
                                                        marginTop: "10px"
                                                    }}
                                                    onClick={() => this.removeLeadUrl(i)}
                                                    
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {this.state.leadUrls.length < 3 && (
                                <div className="form-row">
                                    <img
                                        src="/add.png"
                                        alt="Add"
                                        className="plus-btn"
                                        style={{ width: 24, height: 24, cursor: "pointer", marginLeft: "10px" }}
                                        onClick={this.addLeadUrl}
                                        title="Click here to add Lead Delivery URL" //Anshul-6010: added tooltip for add lead delivery url icon
                                    />
                                </div>
                            )}

                            <div className="section-divider"></div>

                            {/* parameters */}
                            <div className="param-grid">
                                {this.state.parameters.map((p, i) => (
                                    <div className="param-item" key={i} style={{ alignItems: "flex-start" }}>
                                        <div style={{ width: "85%" }}>
                                            <input
                                                className="form-control"
                                                style={{
                                                    width: "100%",
                                                    borderRadius: "10px",
                                                    boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                                                    border: (duplicateParameterIndexes.has(i) || invalidParameterIndexes.has(i)) ? "1px solid #d32f2f" : undefined
                                                }}
                                                placeholder={`Parameter ${i + 1}`}
                                                value={p}
                                                onChange={(e) =>
                                                    this.handleParamChange(i, e.target.value)
                                                }
                                            />
                                            {invalidParameterIndexes.has(i) && (
                                                <div style={{ color: "#e60000", fontSize: "14px", marginTop: "6px" }}>
                                                    <FaExclamationCircle style={{ marginRight: "6px", fontSize: "12px" }} />
                                                    Invalid parameter
                                                </div>
                                            )}
                                            {duplicateParameterIndexes.has(i) && (
                                                <div style={{ color: "#e60000", fontSize: "14px", marginTop: "6px" }}>
                                                    <FaExclamationCircle style={{ marginRight: "6px", fontSize: "12px" }} />
                                                    Parameter already exists.
                                                </div>
                                            )}
                                        </div>
                                        <img
                                            src="/api-remove-icon.png"
                                            alt="Remove"
                                            className="minus-btn"
                                            style={{
                                                width: 20,
                                                height: 20,
                                                cursor: "pointer",
                                                alignSelf: "flex-start",
                                                marginTop: "10px"
                                            }}
                                            onClick={() => this.removeParam(i)}
                                        />
                                    </div>
                                ))}
                            </div>
                            {this.state.parameters.length < 5 && (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        marginTop: "15px",
                                        marginBottom: "10px",
                                        textAlign: "center"
                                    }}
                                >
                                    <div
                                        onClick={this.addParameter}
                                        style={{
                                            padding: "8px 25px",
                                            backgroundColor: "#d9d9d9",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            fontWeight: "500",
                                            boxShadow: "rgba(71,71,71,0.2) 0px 3px 5px",
                                            width: "300px"

                                        }}
                                    >
                                        + Add Parameters
                                    </div>
                                </div>
                            )}

                            <div className="section-divider"></div>

                            <div className="save-row">
                                <button
                                    type="button"
                                    className="btn"
                                    disabled={isSaveDisabled}
                                    onClick={this.submitForm}
                                    style={{
                                        backgroundImage: isSaveDisabled
                                            ? "none"
                                            : "linear-gradient(to left, #0777cb, #103784)",
                                        backgroundColor: isSaveDisabled ? "#5b5b5b" : "transparent",
                                        color: "white",
                                        width: "100px",
                                        height: "30px",
                                        borderRadius: "10px",
                                        boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                                        cursor: isSaveDisabled ? "not-allowed" : "pointer",
                                    }}
                                >
                                    Save
                                </button>


                            </div>

                        </div>
                    )}

                </div>

                <Footer />
            </div>
        );
    }
}

export default connect(
    (state) => ({ auth: state.auth }),
    { logoutUser }
)(withRouter(addApiPortal));
